import React from "react";
import Grid from "@material-ui/core/Grid";
import { useRptAF } from "../../../../St/Reviews/UseStyle";
import MaterialTable from "material-table";
import { stElemnt } from "../../../../St/Reviews/cStyle";
import { reFormatDate } from "../../../../utils/utils";
import { colors} from "@material-ui/core";
import { styleNo } from "../../../Invs/ShareFunctionsPrint";

export function TotalsAccounts({infoData}) {
  const cls = useRptAF();
  return (

    <Grid
      container
      lg={12}
      md={12}
      style={{ paddingTop: "0.3rem", paddingBottom: "0.3rem", backgroundColor: colors.grey[100], fontFamily: "Amiri-Regular" }}
    >
      <Grid container xs={12} /*className={cls.rootchip}*/ style={{
        paddingBottom: 5,
        backgroundColor: colors.grey[100], fontFamily: "Amiri-Regular",
        border: "solid 1px",
        padding: "0.3rem 0.1rem 0.3rem 0.1rem",
        borderRadius: "0px 0px 5px 0px"
      }}>
        <Grid item xs={1} className={[cls.chipVMU]}></Grid>

        <Grid item xs={2} className={[cls.chipVMU]}>
          {infoData?.tot?.totDept}
        </Grid>
        <Grid item xs={2} className={[cls.chipVMU]}>
          {infoData?.tot?.totCredit}
        </Grid>
        <Grid item xs={2} className={[cls.chipVMU]}></Grid>
        <Grid item xs={4} className={[cls.chipTMU]}>
          {"إجمالي الفترة المحددة"}
        </Grid>
      </Grid>
      <Grid container xs={12} /*className={cls.rootchip}*/
        style={{
          paddingBottom: "0.5rem", backgroundColor: colors.grey[100], fontFamily: "Amiri-Regular",
          border: "solid 1px",
          padding: "0.2rem 0.1rem 0.2rem 0.1rem",
          borderRadius: "0px 0px 5px 0px",
        }}>
        <Grid item xs={1} className={[cls.chipVMU]}></Grid>
        <Grid item xs={2} className={[cls.chipVMU]}>
          {infoData?.tot?.totBlncDept}
        </Grid>
        <Grid item xs={2} className={[cls.chipVMU]}>
          {infoData?.tot?.totBlncCredit}
        </Grid>
        <Grid item xs={2} className={[cls.chipVMU]}></Grid>
        <Grid item xs={4} className={[cls.chipTMU]}>
          {"رصيد الفترة المحددة"}
        </Grid>
      </Grid>

    </Grid>
  );
}
function BodyA(props) {
  const { data, isLast,infoData } = props;

  const st_name = {
    width: "32%",
    padding: "0px 0px",
    textAlign: "-webkit-center",
    margin: "0px",
    fontSize: "11px",
    border: "solid 0.1px",
    whiteSpace: "normal",
    wordBreak: "break-word",
    // lineHeight: 1.5,
    overflowWrap: "anywhere",
  }
  var columns = [
    { title: "no", field: "no",cellStyle:styleNo },
    { title: "الرصيد", field: "balance" },
    { title: "مدين", field: "dept" },
    { title: "دائن", field: "credit" },
    { title: "رقم المستند", field: "doc_no" },
    {
      title: "تاريخ المستند",
      field: "date",
      render: (expense) => expense.date!=null? reFormatDate(expense.date):"",
    },
    { title: "رقم المرجع", field: "ref_no" },
    {
      title: "البيان",
      field: "notes",
      cellStyle: st_name,
    },
  ];


  const data2 = data.map((row) => {
    return {
      ...row,
      balance: row.balance.toFixed(2),
      dept: row.dept.toFixed(2),
      credit: row.credit.toFixed(2),
    };
  });
  return (
    <Grid item container style={{ fontFamily: "Amiri-Regular" }}>
      <Grid item container style={{ direction: "rtl", paddingTop: "0.7rem" }}>
        <Grid
          item
          xs={12}
        >
          <MaterialTable
            style={{ boxShadow: "none" ,width:"100%",tableLayout:"fixed"}}
            options={{
              showTitle: false,
              toolbar: false,
              sorting: false,
              selection: false,
              searchFieldAlignment: "left",
              searchFieldVariant: "outlined",
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              pageSize: 5,
              paginationType: "stepped",
              showFirstLastPageButtons: false,

              headerStyle: {
                ...stElemnt.AF.header,
                backgroundColor: colors.grey[100],
                fontWeight: "bold",
                paddingTop: "2px",
                paddingBottom: "2px",
                border: "solid 0px",
                border: "solid 0.1px",
                // display:data.length>0?"table-header-group":"none"
              },
              paging: false,
              cellStyle: {
                ...stElemnt.AF.cell,
                padding: "0px 1px",
              },
            }}
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <h5 style={{ color: "GrayText" }}>
                    لا توجد ارصدة بعد في هذا الحساب
                  </h5>
                ),
              },
            }}
            columns={columns}
            data={data2}
          />
          {isLast && <TotalsAccounts infoData={infoData}/>}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default BodyA;
